import { useContext, useReducer } from 'react'
import { Outlet } from 'react-router-dom'
import { feedbacksReducer } from './feedbacksReducer'
import { feedbacksInitialState } from './feedbacksInitialState'
import FeedbacksContext from './FeedbacksContext'

export const useFeedbacksContext = () => useContext(FeedbacksContext)

export function FeedbacksProvider() {
  const [feedbacksState, feedbacksDispatch] = useReducer(feedbacksReducer, feedbacksInitialState)

  return (
    <FeedbacksContext.Provider value={{ feedbacksState, feedbacksDispatch }}>
      <Outlet />
    </FeedbacksContext.Provider>
  )
}
